import axios from "axios";
import { useAuth } from "@/lib/auth";
import React, { useState } from "react";
import { TeaWordmark } from "@/components/TeaWordmark";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { PARTNER_TOKEN_KEY, parErr, portalApi } from "@/lib/partnerApi";
import { TeaLogo } from "@/components/TeaLogo";

export const PortalShell = ({ title, children, testid }) => (
  <div data-testid={testid} className="min-h-screen bg-[#07080a] text-white flex items-center justify-center px-5 py-16">
    <div className="w-full max-w-md space-y-8">
      <div className="space-y-2"><TeaLogo size={72} testid="partner-login-logo" className="mb-3" /><div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#d4a017]"><TeaWordmark small text="The Exchange Alliance" testid="partner-login-wordmark" /> · Partner Portal</div>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1></div>
      {children}
    </div>
  </div>
);
export const inputCls = "w-full bg-white/[0.04] border border-white/10 focus:border-[#d4a017]/70 outline-none rounded-md px-4 py-3 text-[15px] transition-colors";
export const goldBtn = "w-full inline-flex items-center justify-center gap-2 rounded-md bg-[#d4a017] text-black font-semibold py-3 hover:bg-[#e8b62a] transition-colors disabled:opacity-50";

export default function PartnerLoginPage() {
  const nav = useNavigate();
  const { applySession } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const d = await portalApi.post("/auth/login", { email, password });
      localStorage.setItem(PARTNER_TOKEN_KEY, d.token);
      const desk = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/partner-desk`, null, { headers: { Authorization: `Bearer ${d.token}` } });
      applySession(desk.data.token, desk.data.user);
      nav("/admin");
    }
    catch (err) { setError(parErr(err)); } finally { setBusy(false); }
  };
  return (
    <PortalShell title="Partner sign in" testid="partner-login-page">
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required autoComplete="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="partner-login-email" className={inputCls} />
        <input type="password" required autoComplete="current-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="partner-login-password" className={inputCls} />
        {error && <p data-testid="partner-login-error" className="text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={busy} data-testid="partner-login-submit" className={goldBtn}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in</button>
      </form>
      <p className="text-sm text-white/50">First time here? Use the set-PIN link from your invite email. Staff sign in at <a href="/admin/login" className="text-[#d4a017] hover:underline">/admin/login</a>.</p>
    </PortalShell>
  );
}
